import React, { Component } from 'react';
import { message } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import ExportUtil from "../../../common/ExportUtil";
import TableC from '../../basicElement/TableC';
import Filter from './Filter';

class ContractPlan extends Component {
    state = {
        loading: false,
        pagination: {
            pageSize:10,
            current:1,
        },
        searchParams: {},
        data: [],
    }

    filterDataWithoutObject = (params) => {
        const obj = {};
        for (let [key, value] of Object.entries(params)) {
            if (typeof value !== 'object') {
                obj[key] = value;
            }
        }
        return obj;
    }

    loadData = () =>{
        this.setState({ loading: true });
        const { pagination, searchParams } = this.state;
        const { current, pageSize  } = pagination;
          
        const params = this.filterDataWithoutObject(searchParams);
        
        const options = {
            method: 'POST',
            url: API_URL.home.queryContractPlanVisitReportList,
            data: {   
                offset: current,
                limit: pageSize,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                pagination.total = res.totalCount;
                this.setState({
                    loading: false,
                    data: res.datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (params = {}) => {
        const { pagination,searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: {searchParams,...params},
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams } = this.state;
        const url = API_URL.home.exportContractPlanVisitReport;
        //ExportUtil.export({ ...sortParams, ...searchParams }, null, url);
        this.addToDownloadSite({ ...sortParams, ...searchParams }, url, 'CONTRACT_PLAN_VISIT');
    }

    addToDownloadSite = (searchArray, url, type) => {
        const options = {
            method: 'POST',
            url: API_URL.common.startAsynchronousExport,
            data: { type },
            dataType: 'json',
            doneResult: (res) => {
                const { asynchronousExportId } = res;
                const params = { ...searchArray, asynchronousExportId }
                const options = {
                    method: 'POST',
                    url,
                    data: params,
                    dataType: 'json',
                    doneResult: res => {
                        message.success(res.success);
                    },
                };
                $.sendRequest(options);
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: 'JDE主项目号',
        dataIndex: 'jdeMainCode',
        key: 'jdeMainCode',
        fixed: 'left',
        width: 100,
    }, {
        title: 'JDE项目号',
        dataIndex: 'jdeCode',
        key: 'jdeCode',
        fixed: 'left',
        width: 140,
    }, {
        title: '项目简称',
        dataIndex: 'invName',
        key: 'invName',
        width: 180,
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusinessName',
        key: 'lineOfBusinessName',
        width: 100,
    }, {
        title: '执行二级业务线分类',
        dataIndex: 'secondLineNames',
        key: 'secondLineNames',
        width: 100,
    }, {
        title: '项目分类',
        dataIndex: 'invTypeName',
        key: 'invTypeName',
        width: 150,
    }, {
        title: '项目领域',
        dataIndex: 'invAreaName',
        key: 'invAreaName',
        width: 100,
    }, {
        title: '疾病',
        dataIndex: 'diseaseName',
        key: 'diseaseName',
        width: 100,
    }, {
        title: '项目分期',
        dataIndex: 'invByStageNames',
        key: 'invByStageNames',
        width: 100,
    }, {
        title: '项目阶段',
        dataIndex: 'invStageNames',
        key: 'invStageNames',
        width: 120,
    }, {
        title: '过账编辑',
        dataIndex: 'postingEdit',
        key: 'postingEdit',
        width: 100,
    }, {
        title: '类别码13',
        dataIndex: 'categoryCode13',
        key: 'categoryCode13',
        width: 100,
    }, {
        title: '客户JDE号',
        dataIndex: 'customerJdeCode',
        key: 'customerJdeCode',
        width: 100,
    }, {
        title: '客户名称',
        dataIndex: 'customerCompanyName',
        key: 'customerCompanyName',
        width: 150,
    }, {
        title: 'PM工号',
        dataIndex: 'pmCode',
        key: 'pmCode',
        width: 80,
    }, {
        title: 'PM姓名',
        dataIndex: 'pmName',
        key: 'pmName',
        width: 100,
    }, {
        title: '领域leader工号',
        dataIndex: 'talCode',
        key: 'talCode',
        width: 100,
    }, {
        title: '领域leader姓名',
        dataIndex: 'talName',
        key: 'talName',
        width: 100,
    }, {
        title: 'PML工号',
        dataIndex: 'pmlCode',
        key: 'pmlCode',
        width: 100,
    }, {
        title: 'PML姓名',
        dataIndex: 'pmlName',
        key: 'pmlName',
        width: 100,
    },
     {
        title: '首次合同签署时间',
        dataIndex: 'firstContractSignMonth',
        key: 'firstContractSignMonth',
        width: 100,
    }
    , {
        title: '首次合同签署季度',
        dataIndex: 'firstContractSignQuarter',
        key: 'firstContractSignQuarter',
        width: 100,
    }
    , {
        title: '合同开始时间',
        dataIndex: 'contractStartMonth',
        key: 'contractStartMonth',
        width: 100,
    }
    , {
        title: '合同开始季度',
        dataIndex: 'contractStartQuarter',
        key: 'contractStartQuarter',
        width: 100,
    }
    , {
        title: 'JDE发号时间',
        dataIndex: 'jdeApplyMonth',
        key: 'jdeApplyMonth',
        width: 100,
    }
    , {
        title: '合同中是否明标合同金额',
        dataIndex: 'invJdeContractIsSpecifiesAmount',
        key: 'invJdeContractIsSpecifiesAmount',
        width: 100,
    }
    , {
        title: '服务费含税/人民币',
        dataIndex: 'cnyServiceFeeIncludeTax',
        key: 'cnyServiceFeeIncludeTax',
        width: 100,
    }
    , {
        title: '服务费不含税/人民币',
        dataIndex: 'cnyServiceFeeNoTax',
        key: 'cnyServiceFeeNoTax',
        width: 100,
    }
    , {
        title: '津石计划随机入组数',
        dataIndex: 'jinshiPlanRandomAmount',
        key: 'jinshiPlanRandomAmount',
        width: 100,
    }
    , {
        title: '津石计划访视数',
        dataIndex: 'jinshiPlanVisitAmount',
        key: 'jinshiPlanVisitAmount',
        width: 100,
    }
    , {
        title: '津石计划标准访视数',
        dataIndex: 'jinshiPlanStandardVisitAmount',
        key: 'jinshiPlanStandardVisitAmount',
        width: 100,
    }
    , {
        title: '计划FTE数',
        dataIndex: 'planFteAmount',
        key: 'planFteAmount',
        width: 100,
    }
    , {
        title: '入组单价',
        dataIndex: 'unitPrice',
        key: 'unitPrice',
        width: 100,
    }
    , {
        title: '标访单价',
        dataIndex: 'standardVisitUnitPrice',
        key: 'standardVisitUnitPrice',
        width: 100,
    },
    {
        title: 'FTE单价',
        dataIndex: 'fteUnitPrice',
        key: 'fteUnitPrice',
        width: 100,
    }
]

getDataSource = () => {
    const { data } = this.state;
    let key = 0, idx = 1;
    const dataSource = [];
    if (data && data.length > 0) {
        data.map(item => {
                dataSource.push({
                    key: key++,
                    num: idx++,
                    ...item,
                });
        });
    }
    return dataSource;
}

    handleTableChange = (params) => {
        this.setState({ ...params }, () => {
            this.loadData();
        });
    }

    render() {
        const { loading, pagination } = this.state;
        const dataSource = this.getDataSource();
        const{exportable}=this.props;
        return (
            <div>
                <Filter search={this.search} export={this.export}  type="contractPlan" exportable={exportable}/>
                <TableC
                    loading={loading}
                    scrollY={460}
                    pagination={pagination}
                    columns={this.getColumns()}
                    data={dataSource}
                    onChange={this.handleTableChange}
                />
            </div>
        )
    }
}

export default ContractPlan;


// WEBPACK FOOTER //
// ./src/components/homePage/revenueVisitAndContractPlan/ContractPlan.js